module.exports = __webpack_public_path__ + "img/skill-bg-shape.31e180b7.png";